import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FirebaseService } from './firebase.service';
import { mergeMap } from 'rxjs';

export type RegistrationRecord = {
  registration_id: number;
  active: number;
  account: string;
  expiration?: string;
  guid: string;
  features?: string;
  concurrent?: string;
  multiusers?: string;
  uniqueid?: string;
  otc?: string;
  optionid?: string;
  credit?: string;
  computername?: string;
  lastused?: string;
  information?: string;
};

export type NewDesktopLicenseRecord = RegistrationRecord & {
  products: NewLicenseProduct[];
};

export type DESCreditRecord = RegistrationRecord & {
  linked_to_api_key?: boolean;
};

export type NewLicenseProduct = {
  code: string;
  title: string;
};

export type DesApiKeyLink = {
  has_api_key: boolean;
  has_link_record: boolean;
  linked_to_des_credit: boolean;
  lookup_error?: string;
  multiple_link_records?: boolean;
  link_record_count?: number;
};

export type DesktopLicenseRecords = {
  active: RegistrationRecord[];
  inactive: RegistrationRecord[];
  uncategorized: RegistrationRecord[];
  new_desktop_licenses: NewDesktopLicenseRecord[];
  des_credits?: DESCreditRecord[];
  paf_uuid?: RegistrationRecord;
  des_api_key_link?: DesApiKeyLink;
};

@Injectable({
  providedIn: 'root',
})
export class MachinesService {
  private getMachinesForTenantUrl =
    environment.serverUrl + '/machines/for-tenant';
  constructor(
    private firebaseService: FirebaseService,
    private http: HttpClient
  ) {}

  getMachinesForTenant(tenantId: string) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.get<DesktopLicenseRecords>(
          `${this.getMachinesForTenantUrl}/${tenantId}`,
          {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          }
        );
      })
    );
  }
}
